module.exports = __webpack_public_path__ + "static/media/company-thirteen.983242d4.jpg";